// Lithuanian Numerology Calculator using Pythagorean System
// Specific Lithuanian letter to number mapping

const LITHUANIAN_LETTER_MAP = {
  // 1
  'A': 1, 'Ą': 1, 'J': 1, 'S': 1, 'Š': 1,
  'a': 1, 'ą': 1, 'j': 1, 's': 1, 'š': 1,
  
  // 2
  'B': 2, 'K': 2, 'T': 2,
  'b': 2, 'k': 2, 't': 2,
  
  // 3
  'C': 3, 'Č': 3, 'L': 3, 'U': 3, 'Ų': 3, 'Ū': 3,
  'c': 3, 'č': 3, 'l': 3, 'u': 3, 'ų': 3, 'ū': 3,
  
  // 4
  'D': 4, 'M': 4, 'V': 4,
  'd': 4, 'm': 4, 'v': 4,
  
  // 5
  'E': 5, 'Ę': 5, 'Ė': 5, 'N': 5,
  'e': 5, 'ę': 5, 'ė': 5, 'n': 5,
  
  // 6
  'F': 6, 'O': 6,
  'f': 6, 'o': 6,
  
  // 7
  'G': 7, 'P': 7, 'Y': 7,
  'g': 7, 'p': 7, 'y': 7,
  
  // 8
  'H': 8, 'Z': 8, 'Ž': 8,
  'h': 8, 'z': 8, 'ž': 8,
  
  // 9
  'I': 9, 'Į': 9, 'R': 9,
  'i': 9, 'į': 9, 'r': 9,
};

const VOWELS = ['A', 'Ą', 'E', 'Ę', 'Ė', 'I', 'Į', 'U', 'Ų', 'Ū', 'O', 'Y', 'a', 'ą', 'e', 'ę', 'ė', 'i', 'į', 'u', 'ų', 'ū', 'o', 'y'];

// Reduce number to single digit or master number
function reduceNumber(num, allowMaster = true) {
  if (allowMaster && (num === 11 || num === 22 || num === 33 || num === 44)) {
    return num;
  }
  
  while (num > 9) {
    const digits = num.toString().split('');
    num = digits.reduce((sum, digit) => sum + parseInt(digit), 0);
    
    if (allowMaster && (num === 11 || num === 22 || num === 33 || num === 44)) {
      return num;
    }
  }
  
  return num;
}

// Calculate Life Path Number from birth date
export function calculateLifePath(day, month, year) {
  const dayReduced = reduceNumber(parseInt(day));
  const monthReduced = reduceNumber(parseInt(month));
  const yearReduced = reduceNumber(parseInt(year));
  
  const sum = dayReduced + monthReduced + yearReduced;
  return reduceNumber(sum);
}

// Calculate Expression Number from full name
export function calculateExpression(fullName) {
  let sum = 0;
  const cleanName = fullName.replace(/[^A-ZĄČĘĖĮŠŲŪŽa-ząčęėįšųūž]/g, '');
  
  for (let char of cleanName) {
    if (LITHUANIAN_LETTER_MAP[char]) {
      sum += LITHUANIAN_LETTER_MAP[char];
    }
  }
  
  return reduceNumber(sum);
}

// Calculate Soul Number from vowels in name
export function calculateSoul(fullName) {
  let sum = 0;
  const cleanName = fullName.replace(/[^A-ZĄČĘĖĮŠŲŪŽa-ząčęėįšųūž]/g, '');
  
  for (let char of cleanName) {
    if (VOWELS.includes(char) && LITHUANIAN_LETTER_MAP[char]) {
      sum += LITHUANIAN_LETTER_MAP[char];
    }
  }
  
  return reduceNumber(sum);
}

// Calculate Personality Number from consonants in name
export function calculatePersonality(fullName) {
  let sum = 0;
  const cleanName = fullName.replace(/[^A-ZĄČĘĖĮŠŲŪŽa-ząčęėįšųūž]/g, '');
  
  for (let char of cleanName) {
    if (!VOWELS.includes(char) && LITHUANIAN_LETTER_MAP[char]) {
      sum += LITHUANIAN_LETTER_MAP[char];
    }
  }
  
  return reduceNumber(sum);
}

// NAUJA VIENINGA FORMULĖ - Asmeninės dienos skaičiavimas
// 1. Asmeniniai metai = reduce(Gimimo diena + Gimimo mėnuo + Einamieji metai)
// 2. Asmeninis mėnuo = reduce(Asmeniniai metai + Einamojo mėnesio numeris)
// 3. Asmeninė diena = reduce(Asmeninis mėnuo + Einamoji dienos data)
export function calculateDaily(day, month, year) {
  const today = new Date();
  const currentDay = today.getDate();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();
  
  // 1. Asmeniniai metai
  const yearDigits = currentYear.toString().split('').map(Number).reduce((a, b) => a + b, 0);
  const personalYear = reduceNumber(parseInt(day) + parseInt(month) + yearDigits, false);
  
  // 2. Asmeninis mėnuo
  const personalMonth = reduceNumber(personalYear + currentMonth, false);
  
  // 3. Asmeninė diena
  const personalDay = reduceNumber(personalMonth + currentDay, false);
  
  return personalDay;
}

// Eksportuojame atskiras funkcijas naujam skaičiavimui
export function calculatePersonalYear(day, month, currentYear) {
  const yearDigits = currentYear.toString().split('').map(Number).reduce((a, b) => a + b, 0);
  return reduceNumber(parseInt(day) + parseInt(month) + yearDigits, false);
}

export function calculatePersonalMonth(personalYear, currentMonth) {
  return reduceNumber(personalYear + currentMonth, false);
}

export function calculatePersonalDay(personalMonth, currentDay) {
  return reduceNumber(personalMonth + currentDay, false);
}

// Calculate Compatibility between two people - Updated with provided harmony percentages
export function calculateCompatibility(lifePath1, lifePath2) {
  const numbers = [lifePath1, lifePath2].sort();
  const key = numbers[0] * 10 + numbers[1]; // Unique key for each combination
  
  // Compatibility matrix - updated with user-provided harmony percentages
  const compatibilityMatrix = {
    // Number 1 combinations (from provided data)
    11: 75,  // 1-1: 75%
    12: 88,  // 1-2: 88%
    13: 92,  // 1-3: 92%
    14: 82,  // 1-4: 82%
    15: 85,  // 1-5: 85%
    16: 90,  // 1-6: 90%
    17: 78,  // 1-7: 78%
    18: 80,  // 1-8: 80%
    19: 95,  // 1-9: 95%
    // Number 2 combinations (from provided data)
    22: 70,  // 2-2: 70%
    23: 85,  // 2-3: 85%
    24: 92,  // 2-4: 92%
    25: 65,  // 2-5: 65%
    26: 95,  // 2-6: 95%
    27: 80,  // 2-7: 80%
    28: 78,  // 2-8: 78%
    29: 90,  // 2-9: 90%
    // Number 3 combinations (from provided data)
    33: 80,  // 3-3: 80%
    34: 68,  // 3-4: 68%
    35: 90,  // 3-5: 90%
    36: 94,  // 3-6: 94%
    37: 65,  // 3-7: 65%
    38: 82,  // 3-8: 82%
    39: 96,  // 3-9: 96%
    // Number 4 combinations
    // Number 4 combinations (updated with user-provided harmony percentages)
    44: 75, 45: 60, 46: 88, 47: 80, 48: 85, 49: 72,
    // Number 5 combinations (updated with user-provided harmony percentages)
    55: 94, 56: 75, 57: 82, 58: 88, 59: 92,
    // Number 6 combinations
    // Number 6 combinations (updated with user-provided harmony percentages)
    66: 82, 67: 70, 68: 92, 69: 98,
    // Number 7 combinations (updated with user-provided harmony percentages)
    77: 85, 78: 75, 79: 92,
    // Number 8 combinations
    // Number 8 combinations (updated with user-provided harmony percentages)
    88: 70, 89: 90,
    // Number 9 combinations
    // Number 9 combinations (updated with user-provided harmony percentages)
    99: 85
  };
  
  return compatibilityMatrix[key] || 75; // Default 75% if not in matrix
}

// Get all numbers for a person
export function calculateAllNumbers(firstName, lastName, day, month, year) {
  const fullName = `${firstName} ${lastName}`;
  
  return {
    lifePath: calculateLifePath(day, month, year),
    expression: calculateExpression(fullName),
    soul: calculateSoul(fullName),
    personality: calculatePersonality(fullName),
    daily: calculateDaily(day, month, year)
  };
}
